// Libraries
var React = require('react');
var ReactDOMServer = require('react-dom/server');
var $ = require('jquery');
var GenericImage = require('../GenericImage/GenericImage');
var GenericRichText = require('../RichText/GenericRichText');
var Icon = require('../../common/Icon/Icon.js');

// Style
require("slick-carousel/slick/slick.css");
require("slick-carousel/slick/slick-theme.css");
require('./KeyFacts.scss');

class KeyfactsModule extends React.Component {
  constructor(props) {

    super(props);

    const chevron = ReactDOMServer.renderToString(<Icon className="" name="chevronLeft" />);

    this.settings = {
      accessibility: true,
      dots: true,
      infinite: true,
      arrows: true,
      speed: 500,
      autoplay: false,
      autoplaySpeed: 7500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      fade: true,
      pauseOnHover: false,
      customPaging: function (slider, i) {
        return '<button type="button" class="c-key-facts__pagination-button" data-pagination-button><span class="c-key-facts__pagination-button__value">' + props.data.items[i].value + '</span><span class="c-key-facts__pagination-button__suffix">' + props.data.items[i].suffix + '</span></button>';
      },
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><span class="u-visually-hidden">Previous</span>' + chevron + '</button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><span class="u-visually-hidden">Next</span>' + chevron + '</button>'
    };

    this.state = {
      lastWindowHeight: 0
    }

  }

  componentDidMount() {

    if (this.props.data.items.length <= 1) return;

    // this is here to prevent window being undefined when rendered server side
    require('slick-carousel');

    var gallery = $(this.gallery);

    gallery.not('.slick-initialized').slick(this.settings);

    setTimeout(function () { gallery.get(0).querySelector('.slick-dots li:first-child').classList.add('is-active'); }, 10); // req so the first item animates

    gallery.on('afterChange', function (slick, currentSlide) {

      let current = slick.currentTarget.querySelector('.is-active');
      current.classList.remove('is-active');
      slick.currentTarget.querySelector('.slick-dots li:nth-child(' + (currentSlide.currentSlide + 1) + ')').classList.add('is-active');

    });

    gallery.find('.slick-dots').wrap('<div class="c-key-facts__pagination"></div>');

    gallery.find('[data-pagination-button], .slick-arrow').each(function () {

      $(this).focus(function () {
        gallery.addClass('is-focus');
      }).blur(function () {
        gallery.removeClass('is-focus');
      });

    });

    gallery.on('swipe', function() {
      gallery.slick('slickPause');
      gallery.addClass('is-focus');
    });

    $('[data-pagination-button], .slick-arrow').on('click', function(){
      gallery.slick('slickPause');
      gallery.addClass('is-focus');
    });

    this.initAutoplayWhenInViewport(gallery);

  }

  initAutoplayWhenInViewport(gallery) {

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver((entries, self) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            gallery.slick('slickPlay');
            gallery.addClass('autoplay-started');
            observer.unobserve(this.gallery);
          }
        });
      },
        {
          rootMargin: '0px 0px -50%'
        }
      );
      observer.observe(this.gallery);
    } else {
      gallery.slick('slickPlay');
    }

  }

  render() {
    const additionalKeyFactsClass = this.props.data.isOneHotspur ? ' c-key-facts--one-hotspur' : this.props.data.isPremium ? ' c-key-facts--premium' : '';
    const buttonKeyFactsClass = this.props.data.isOneHotspur ? ' c-button--one-hotspur'  : this.props.data.isPremium ? ' c-button--premium' : 'c-button--outline';

    return (
      <div id={this.props.data.id} className={`c-key-facts${additionalKeyFactsClass}${(this.props.data.items.length <= 1) ? " c-key-facts--lonely" : ""}`}>
        {this.props.data.items.length &&
          <div className="c-key-facts__wrapper">
            <div className="c-key-facts__wrapper__inner" ref={g => this.gallery = g}>
              {this.props.data.items.map((item, index) => {
                return (
                  <div key={index} className="c-key-facts__item">
                    <div className="c-key-facts__item__inner">
                      <div className="c-key-facts__copy">
                        {(item.value && item.suffix) &&
                          <h2 className="c-key-facts__title">
                            <span className="c-key-facts__value">{item.value}</span>
                            <span className="c-key-facts__suffix">{item.suffix}</span>
                          </h2>
                        }
                        <div className="c-key-facts__copy__main">
                          <GenericRichText content={item.richtext} isPremium={this.props.data.isPremium} largeText="true" />
                          {(item.link.url && item.link.caption) &&
                            <p className="c-key-facts__action"><a href={item.link.url} className={`c-button c-button--on-dark ${buttonKeyFactsClass}`}>{item.link.caption}</a></p>
                          }
                        </div>
                      </div>
                    </div>
                    <div className="c-key-facts__image-container">
                      <GenericImage loading="lazy" image={item.image} class="c-key-facts__image" />
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        }
      </div>
    );
  }
};

module.exports = KeyfactsModule;


// WEBPACK FOOTER //
// ./src/components/KeyFacts/KeyFacts.js